import {
  ADD_GLOBAL_ERROR,
  DEFAULT_GLOBAL_ERROR_MESSAGE,
  OPEN_PAGE,
  REMOVE_GLOBAL_ERROR,
  SELECT_ANNUAL_PAYMENT_MODE,
  SELECT_MONTHLY_PAYMENT_MODE,
  SET_HAS_EMAIL,
  START_LOADER,
  STOP_LOADER,
  UPDATE_ACTIVE_IDS,
} from 'containers/App/constants';

const EMPTY_OBJECT = {};

export const openTrustPilot = () =>
  openPage('https://www.trustpilot.com/review/policygenius.com', '_blank');

export const openPage = (
  url: string,
  target: string,
  analytics: Record<string, string> = EMPTY_OBJECT
) => {
  let meta: Record<string, Record<string, string>>;

  setTimeout(() => {
    window.open(url, target);
  }, 0);

  if (analytics === EMPTY_OBJECT) {
    meta = {};
  } else {
    meta = { analytics: { ...analytics } };
  }

  return {
    type: OPEN_PAGE,
    payload: { url, target },
    meta,
  };
};

export const addGlobalError = (error: string = DEFAULT_GLOBAL_ERROR_MESSAGE) => ({
  type: ADD_GLOBAL_ERROR,
  payload: error,
});

export const removeGlobalError = () => ({
  type: REMOVE_GLOBAL_ERROR,
});

export const startLoader = () => ({ type: START_LOADER });
export const stopLoader = () => ({ type: STOP_LOADER });

export const updateActiveIds = (payload: Record<string, string>) => ({
  type: UPDATE_ACTIVE_IDS,
  payload,
});

export const selectMonthlyPaymentMode = (uuid: string) => ({
  type: SELECT_MONTHLY_PAYMENT_MODE,
  payload: uuid,
});

export const selectAnnualPaymentMode = (uuid: string) => ({
  type: SELECT_ANNUAL_PAYMENT_MODE,
  payload: uuid,
});

export const setHasEmail = () => ({ type: SET_HAS_EMAIL });
